import React from 'react'
import { Box, Flex } from '@chakra-ui/core'
import styled from '@emotion/styled'
import { AdminSidebar } from './AdminSidebar'
import Header from 'components/Header'
import { Outlet, useLocation } from 'react-router-dom'

const AdminContainer = styled(Flex)`
  min-height: calc(100vh - 94px);
  margin-top: 94px;
  background-color: white;
`

const MainContent = styled(Box)`
  flex: 1;
  padding: 1rem;
  height: calc(100vh - 94px);
  overflow-y: auto;
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`

export const AdminConsole: React.FC = () => {
  const location = useLocation()
  const activeSection = location.pathname.split('/').pop() || 'users'

  return (
    <AdminContainer>
      <Header />
      <AdminSidebar activeSection={activeSection} />
      <MainContent>
        <Outlet />
      </MainContent>
    </AdminContainer>
  )
}
